export const NUMBER_TYPE = 'number';
export const PERCENT_TYPE = 'percent';
